export default "__VITE_ASSET__D8IqRVnK__"